import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './Component_TagEditor.scss';
import { _className, Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { filterDuplicates, removeFromArray } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { HCSDropDowns } from '../app-dropdowns.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ConfigKeyFE_SourceTagId, ModuleFE_Tag } from '../../../_entity.js';
export class Component_TagEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.disableEdit = nextProps.disableEdit ?? false;
        state.groupTagFilter = nextProps.groupTagFilter;
        state.sourceTagId = ConfigKeyFE_SourceTagId.get();
        // state.tagGroupKeys = filterDuplicates([...nextProps.tags.map(tagGroup => tagGroup.key), ...(state.tagGroupKeys ?? [])], tagGroup => tagGroup._id);
        state.tagGroupKeys = filterDuplicates(nextProps.tags.map(tagGroup => tagGroup.key), tagGroup => tagGroup._id);
        return state;
    }
    renderTag(tag, pair) {
        return _jsxs("div", { className: 'tag', children: [!this.state.disableEdit && _jsx(Button, { onClick: () => {
                        pair.value = pair.value.filter(item => item._id !== tag._id);
                        this.forceUpdate(() => this.props.onChange?.());
                    }, children: _jsx(ICONS.x.component, {}) }), _jsx("span", { children: tag.label })] }, tag._id);
    }
    renderInnerTags(pair) {
        const tagDDClassName = _className(!this.props.hideDropdownDesign && 'tag-dropdown');
        return _jsxs(LL_H_C, { className: 'tags', children: [pair.value.map(tag => this.renderTag(tag, pair)), !this.state.disableEdit &&
                    _jsx(HCSDropDowns.Tag, { className: tagDDClassName, selected: undefined, onSelected: item => {
                            pair.value.push(item);
                            this.forceUpdate(() => this.props.onChange?.());
                        }, placeholder: 'New Tag', onNoMatchingSelectionForString: async (label) => {
                            const tag = ModuleFE_Tag.cache.find(t => t.label === label);
                            if (tag)
                                return this.logWarning('Tag with label already exists: ', tag);
                            const newTag = await ModuleFE_Tag.v1.upsert({ label, tagIds: [pair.key._id] }).executeSync();
                            pair.value.push(newTag);
                            this.forceUpdate(() => this.props.onChange?.());
                        }, queryFilter: item => {
                            if (pair.value.findIndex(val => val._id === item._id) !== -1)
                                return false; // don't allow adding the same tag twice
                            return this.props.singleTagFilter(item, pair.key);
                        }, caret: DropDown_DefaultCaret, boundingParentSelector: '.ts-tabs__content' })] });
    }
    renderTagGroups = () => {
        return this.state.tagGroupKeys?.map(tagGroupKey => {
            const uiTagGroup = this.props.tags.find(tagGroup => tagGroup.key._id === tagGroupKey._id);
            const pair = uiTagGroup ?? {
                key: tagGroupKey,
                value: []
            };
            if (!uiTagGroup)
                this.props.tags.push(pair);
            return _jsxs(LL_V_L, { className: 'tag-group', children: [_jsxs(LL_H_C, { className: 'tag-group__title', children: [_jsx("span", { children: pair.key.label }), !this.state.disableEdit && (!this.props.mandatoryRootTag || this.props.mandatoryRootTag && pair.key._id !== this.state.sourceTagId)
                                && _jsx(ICONS.x.component, { onClick: () => {
                                        //remove tag group
                                        removeFromArray(this.props.tags, item => item.key._id === pair.key._id);
                                        removeFromArray(this.state.tagGroupKeys, item => item._id === pair.key._id);
                                        this.forceUpdate(() => this.props.onChange?.());
                                    } })] }), this.renderInnerTags(pair)] }, pair.key._id);
        });
    };
    renderAddGroupDropDown = () => {
        if (this.state.disableEdit)
            return _jsx(_Fragment, {});
        return _jsx(HCSDropDowns.Tag, { selected: undefined, onSelected: cat => {
                let existingPair = this.props.tags?.find(pair => pair.key._id === cat._id);
                if (!existingPair)
                    existingPair = { key: cat, value: [] };
                this.props.tags.push(existingPair);
                this.state.tagGroupKeys.push(cat);
                this.forceUpdate(() => this.props.onChange?.());
            }, queryFilter: item => {
                if (this.props.tags.findIndex(group => group.key._id === item._id) !== -1)
                    return false; // don't allow adding the same group twice
                if (item.tagIds[0])
                    return false; // don't allow non-root related groups
                return this.props.groupTagFilter(item);
            }, placeholder: 'New Tag Group', caret: DropDown_DefaultCaret, boundingParentSelector: '.ts-tabs__content' });
    };
    render() {
        const className = _className('tags-section', this.state.disableEdit && 'edit-disabled');
        return (_jsx(LL_V_L, { className: className, children: _jsxs(LL_V_L, { className: 'dialog__field-content', children: [this.renderTagGroups(), this.renderAddGroupDropDown()] }) }));
    }
}
//# sourceMappingURL=Component_TagEditor.js.map